import React from 'react';

import fetch from './fetch';

/**
 * @method querySearchByName
 * @param {object} keywords
 * @return {promise}
 */
const querySearchBySchool = (keywords ={}) => {
    return fetch.post('school/list', keywords)
    .then(response => {
        return response.payload.data.dataList.map(d => ({
            value: d.id,
            label: d.name
        }));
    });
}

/**
 * @method sendPhoneCode
 * @param {object} keywords
 * @return {promise}
 */
const sendPhoneCode = (keywords ={}) => {
    return fetch.post('clouduser/kaptcha', keywords);
}

/**
 * @method checkPhoneNumber
 * @param {object} keywords
 * @return {promise}
 */
const checkPhoneNumber = (keywords ={}) => {
    return fetch.post('clouduser/validphone', keywords).then(response => response.payload.data);
}

/**
 * @method checkPhoneNumber
 * @param {object} keywords
 * @return {promise}
 */
const userToRegister = (keywords ={}) => {
    return fetch.post('clouduser/register', keywords).then(response => response);
}

const querySearch = (keywords ={}) => {
    return fetch.post('clouduser/list', keywords).then(response => response);
}



export default {
    querySearchBySchool,
    sendPhoneCode,
    checkPhoneNumber,
    userToRegister,
    querySearch
}